module.exports = __webpack_public_path__ + "media/images/responsive/page_common/bg_gray_paper-ed802087b5f7ceaf52864d92dc89d729.png";